const baseUrl = 'http://dwlr690.upgwddwlr.in/v1'
// const baseUrl = '/v1'

export default baseUrl
